// ServicePath
export const AdministrationServicePath = "administration/";
export const StudentServicePath = "student/";
export const SpecialistServicePath = "specialist/";
export const LeavesServicePath = "leaves/";
export const EmployeeServicePath = "employee/";
export const CandidateServicePath = "candidate/";
export const GraduationServicePath = "graduation/";
export const CareerCenterServicePath = "career-center/";
export const ScholarshipServicePath = "scholarship/";
export const ActivityServicePath = "activity/";
export const NotificationServicePath = "notification/";
export const ReportingServicePath = "reporting/";
export const PaymentServicePath = "payment/";
export const AccountServicePath = "account/";
export const AlumniServicePath = "alumni/";
export const ErasmusServicePath = "erasmus/";
export const DocumentServicePath = "document/";
export const DebtServicePath = "debt/";
export const DoctoralServicePath = "doctoral/";
export const DormitoryServicePath = "dormitory/";
export const GoogleServicePath = "google/";
export const NacidServicePath = "nacid/";
export const PublicationServicePath = "publication/";

export const INTERNSHIP_INCOMING_ERASMUS = "incoming/internship-students";
export const REGULAR_INCOMING_ERASMUS = "incoming/students/regular";
export const TEACHERS_INCOMING_ERASMUS = "incoming/employees";
export const TEACHERS_OUTGOING_ERASMUS = "outgoing/employees";
export const COORDINATORS_ERASMUS = "coordinators";

export const APPLICATIONS = "applications";
export const APPLICATIONS_DETAILS = "applications-details";
export const JOBS = "job-offers";
export const EMPLOYERS = "employers";
export const ALUMNI = "alumni";
export const EMPLOYEES = "employees";
export const EVENTS = "events";
export const STUDENTS_PATH = "student/students";
export const STUDENTS = "student/students/education";
export const STUDENT_EDUCATION = "student-educations";
export const RECORDS = "records";
export const EDUCATION_PREPARATORY = "education-preparatory";
export const EDUCATION_STUDENTS = "education-students";
export const SPECIALISTS = "specialists";
export const DIRECTIONS = "directions";
export const HEALTH_INSURANCES = "health-insurances";
export const PROFESSIONAL_DIRECTIONS = "professional-directions";
export const ANNUAL_FEES = "annual-fees";
export const BUILDINGS = "buildings";
export const PREFERENCES = "preferences";
export const ROOMS = "rooms";
export const PUBLICATIONS = "publications";
export const SESSION_EXAMS = "session-exams";
export const CYCLIC_EXAMS = "cyclic-exams";
export const SESSION_EXAMS_PROFESSORS = `${SESSION_EXAMS}/professors`;
export const PROFESSORS = "professors";
export const PROFESSORS_EXAMS = "professors-exams";
export const STRUCTURAL_UNITS = "structural-units";
export const TREE = "tree";
export const STUDY_DEPARTMENT_INFO = "study-department-info";
export const CAMPAIGNS = "campaigns";
export const POSTGRADUATE_COURSES = "postgraduate-courses";
export const PRELIMINARY = "preliminary";
export const COURSES = "courses";
export const REGULAR = "regular";
export const PAID = "paid";
export const PREPARATORY = "preparatory";
export const HOSPITAL_CONTRACTS = "hospital-contracts";
export const SPECIALITIES = "specialities";
export const SPECIALITY_GROUPS = "speciality-groups";
export const EQUIPMENT = "equipment";
export const TECHNICAL_EQUIPMENT = "technical-equipment";
export const DECLARATIONS = "declarations";
export const POSITION_TYPES = "positions/types";
export const POSITIONS = "positions";
export const SCIENTIFIC_DEGREES = "scientific-degrees";
export const EXAMS = "exams";
export const DISCIPLINES = "disciplines";
export const ACADEMIC_YEARS = "academic-years";
export const SESSIONS = "sessions";
export const SEMESTERS = "semesters";
export const ACADEMIC_SESSIONS = "academic-years/sessions";
export const DEPARTMENTS = "departments";
export const BANK_TRANSFERS = "bank-transfers";
export const ONLINE_PAYMENTS = "online-payments";
export const CASH_PAYMENTS = "cash-payments";
export const PAYMENT_EXPECTATIONS = "payment-expectations";
export const DEBTS = "debts";
export const DEPOSITS = "deposits";
export const CAMPAIGN_RANKINGS = "campaigns/ranking";
export const CURRICULUMS = "curriculums";
export const MODULES = "modules";
export const CURRICULUM_SELECTION_CAMPAIGNS = "curriculum-selection-campaigns";
export const CURRICULUM_SELECTION_CAMPAIGN_APPLICATIONS = "curriculum-selection-campaign-applications";
export const CURRICULUM_SELECTION_CAMPAIGN_APPLICATIONS_DETAILS = "curriculum-selection-campaign-applications-details";
export const ELECTIVE_COURSES = "elective-courses";
export const SETTLEMENTS = "settlements";
export const DISTRICTS = "districts";
export const MUNICIPALITIES = "municipalities";
export const CLINICS = "clinics";
export const ROOM_TYPES = "room-types";
export const ROOM_CONDITIONS = "room-conditions";
export const PRICES = "prices";
export const ACCOMMODATION_PRICES = "accommodation-prices";
export const SUBSIDIES = "subsidies";
export const STATE_SUBSIDIES = "state-subsidies";
export const ACCOMMODATIONS = "accommodations";
export const ACCOMMODATED_STUDENTS = "accommodated-students";
export const ACCOMMODATION_ORDERS = "accommodation-orders";
export const ACCOMMODATION_PAYMENTS = "accommodations/payments";
export const HOSPITALITIES = "hospitalities";
export const BUDGETS = "budgets";
export const SPECIFIC_REQUIREMENTS = "specific-requirements";
export const CYCLIC_SCHEDULE = "cyclic-streams";
export const PREPARATORY_SCHEDULES = "preparatory-schedules";
export const PREPARATORY_CLASSES = "preparatory-classes";
export const WEEKLY_SCHEDULE = "schedules/weekly";
export const WEEKLY_TABBED_SCHEDULE = "schedules/weekly-tabbed";
export const WEEKLY_STREAM_SCHEDULE = "schedules/weekly-streams";
export const WEEKLY_SCHEDULE_DISCIPLINES = "schedules/weekly/disciplines";
export const WEEKLY_SCHEDULE_NON_WORKING_OCCURRENCES = "schedules/weekly/disciplines/non-working-occurrences";
export const NON_WORKING_OCCURRENCES = "schedules/non-working-occurrences";
export const FOR_UPDATE = "for-update";
export const CLASSES = "classes";
export const ATTENDANCE = "attendance";
export const ACADEMIC_REQUESTS = "academic-requests";
export const ACADEMIC_REQUEST_DATA_ISSUES = "academic-request-data-issues";
export const DATA_ISSUES = "data-issues";
export const STAFF_REQUEST = "staff-requests";
export const REQUESTS_HISTORY = "requests-history";
export const CAMPS = "camps";
export const ACADEMIC_DECISIONS = "academic-decisions";
export const MAKE_UPS = "make-ups";
export const CYCLIC_EXAM_EXCEPTIONS = "cyclic-exam-exceptions";
export const WARDS = "wards";
export const TRAINING_BASES = "training-bases";
export const THESIS_DEFENSE = "thesis-defense";
export const GRADUATED_STUDENT_DOCUMENTS = "graduated-students/documents";
export const MONTHLY_INTERNSHIP = "monthly-internship";
export const SPECIALIZATIONS = "specializations";
export const OPTIONS = "options";
export const DETAILS = "details";
export const ADVANCED_SPECIALIZATIONS = "advanced-specializations";
export const ADVANCED_SPECIALIZATION_SPECIALIST = "advanced-specialization-specialists";
export const HEALTHCARE_CAMPAIGNS = "healthcare-campaigns";
export const HEALTHCARE_CAMPAIGNS_APPLICATIONS = "healthcare-campaigns-applications";
export const HEALTHCARE_CAMPAIGNS_APPLICATIONS_DETAILS = "healthcare-campaigns-applications-details";
export const HEALTHCARE_COURSES = "healthcare-courses";
export const HEALTHCARE_COURSE_DAILY_PRICES = "healthcare-course-daily-prices";
export const HEALTHCARE_COURSE_FEE_DISTRIBUTION = "healthcare-courses-fee-distributions";
export const FEE_DISTRIBUTION = "fee-distributions";
export const EXAM_COMMITTIEES = "exam-committees";
export const NACID_FLOWS = "nacid-flows";
export const NACID_COVERAGE = "nacid-coverage";
export const CURRICULA = "curricula";

export const CANDIDATE_STATES = "candidacies/states";
export const CANDIDACIES = "candidacies";
export const CANDIDATES = "candidates";
export const CANDIDACIES_PRELIMINARY = "preliminary/candidacies";
export const CANDIDACIES_REGULAR = "regular/candidacies";
export const CANDIDACIES_PAID = "paid/candidacies";
export const CANDIDACIES_COURSES = "courses/candidacies";
export const CANDIDACIES_HOSPITAL_CONTRACTS = "hospital-contracts/candidacies";

export const IBANS = "ibans";
export const SCHOOL_SUBJECTS = "school-subjects";
export const GROUPS = "groups";
export const STUDY_GROUPS = "study-groups";
export const STREAMS = "streams";
export const PRIVATE_DOCUMENTS = "private-documents";
export const PUBLIC_DOCUMENTS = "public-documents";
export const EMAILS_GROUPS = "emails/groups";
export const EMAILS = "emails";
export const SENT_EMAILS = "sent-emails";
export const EMAIL_GROUPS = "email-groups";
export const INTERMEDIARIES = "intermediaries";
export const GRADING_SCALES = "grading-scales";
export const COUNTRIES = "countries";
export const BLACK_LIST = "blacklists";
export const LEAVES_REQUESTS = "leaves-requests";

export const USERS_INFO = "users/info";
export const USERS = "users";
export const CANDIDATE_USERS = "users/candidates";
export const PREPARATORY_YEARS = "preparatory-years";
export const PREPARATORY_COURSES = "preparatory-courses";
export const ROLES = "roles";
export const PERMISSIONS = "permissions";
export const SELECT_CITIZENSHIP = "selects/citizenship";
export const RECEPTION_TYPES = "reception-types";

export const CANDIDATE_ROLE = "Candidate";

export const REPORTS = "reports";
export const REPORTS_PRELIMINARY_CANDIDATE = "reports/preliminary-candidate";
export const REPORTS_FINANCIAL = "reports/financial";
export const REPORTS_ACADEMIC = "reports/academic";
export const REPORTS_STUDENT = "reports/student";

export const LEAVES_USED_VACATIONS = "leaves-used-vacations";
export const LEAVES = "leaves";

export const BUSINESS_TRIPS = "leaves/business-trips";
export const SICK_LEAVES = "leaves/sick-leaves";
export const VACATIONS = "leaves/vacations";
export const BUSINESS_TRIP_REPORTS = "leaves/business-trip-reports";
export const BUSINESS_TRIPS_LIST = "leaves/business-trips/mine";
export const SICK_LEAVES_LIST = "leaves/sick-leaves/mine";
export const VACATION_LIST = "leaves/mine";
export const NODE_LEAVES_LIST = "leaves/node";

export const VACATION_PERIODS_LIMIT = 3;
export const VACATION_FILES_LIMIT = 3;
export const NODE_LEAVE_FILES_LIMIT = 5;

export const OTHER_UNIVERSITIES = "other-universities";
export const UNIVERSITIES = "universities";

export const ATTESTATIONS = "attestations";
export const ATTESTATIONS_INCOMPLETE_SEMESTERS = "attestations-incomplete-semesters";
export const ATTESTATIONS_MANAGEMENT = "attestations-management";

export const FOREIGN_LANGUAGES = "foreign-languages";
export const ACTIVITIES = "activities";
export const SPORTS = "sports";
export const LEVELS = "levels";
export const ASSIGNMENTS = "assignments";
export const INCOMPLETE_SEMESTERS = "incomplete-semesters";

export const PRACTICES = "practices";
export const INTERNSHIPS = "internships";
export const STATE_EXAMS = "state-exams";
export const TOPICS = "topics";

export const CAPACITIES = "/capacities";
export const MANAGE_CAPACITY = "manage-capacity";

export const INTERNSHIP_SESSIONS = "internship-sessions";
export const INDIVIDUAL_SLOTS = "individual/slots";
export const FREE_SELECTION_SLOTS = "free-selection/slots";
export const PLANS = "plans";
export const SCHEDULES = "schedules";
export const CYCLES = "cycles";
export const INDIVIDUAL_CYCLES = "individual-cycles";

export const ADMIN_LOGIN = "admin-login";

// UI/config
export const MOBILE_BREAKPOINT = "(max-width:1024px)";
export const ONE_DAY_IN_SECONDS = 1000 * 60 * 60 * 24;
export const SELECT_ALL = -1;
export const BULGARIA_COUNTRY_ID = 21;
export const MAX_SEMESTER = 20;

export const DEOS_STRUCTURAL_UNIT_ID = 7;
export const SETTLEMENT_WITH_AREA_QUERY = "showDistrictAndMunicipality=true";
export const SICK_LEAVE_DOCUMENT_TYPE = "Болничен";
// The QR code lifetime comes from the X-Expires-In-Seconds response header; this is only
// the fallback used when that header is missing, so the code never stops refreshing
export const CLASS_ATTENDANCE_QR_FALLBACK_REFRESH_SECONDS = 5;
export const ALLOWED_FILE_EXTENSIONS = [".jpeg", ".jpg", ".png", ".pdf", ".docx"];

// Enums
export const CampaignSeason = {
  Spring: 1,
  Autumn: 2,
};

export const CommissionMemberRole = {
  Chairman: 1,
  Member: 2,
};

export const InstructionLanguage = {
  Bulgarian: 1,
};

export const AdmissionReason = {
  WithoutCompetitiveExam: 3,
};

export const ReceptionType = {
  StateOrder: 1,
  PaidOrder: 2,
};

export const PmsTypes = {
  PMS103: 1,
  PMS228: 2,
};

export const RoomSource = {
  Room: 1,
  GoogleCourse: 2,
};

export const PmsAdmissionReason = {
  Pms103FAdmissionReasonId: 14,
  Pms103S26AdmissionReasonId: 26,
  Pms228AdmissionReasonId: 15,
};

export const AttestationStatus = {
  Verified: 1,
  Unverified: 2,
  AwaitingVerification: 3,
};

export const IndividualCurriculumStatus = {
  None: 0,
  SignedOffWithoutExam: 1,
  SignedOffWithExam: 2,
  NotAttended: 3,
  Deferred: 4,
};

export const DoctoralSeatStatus = {
  PendingApproval: 1,
  ApprovedByFc: 2,
  ApprovedByAc: 3,
  ApprovedByMon: 4,
  Declined: 5,
};

export const DoctorantCandidacyStatus = {
  Submitted: 1,
  AdmittedToExam: 2,
  NotAdmitted: 3,
  ObjectionUnderReview: 4,
  Declined: 5,
  AdmittedToLanguageExam: 6,
  Failed: 7,
  Admitted: 8,
  NotRanked: 9,
};

export const DoctorantStatus = {
  Active: 1,
  DismissedWithRightToDefend: 2,
  DismissedExpiredTerm: 3,
  DismissedWithoutRightToDefend: 4,
  DefendedSuccessfully: 5,
  Interrupted: 6,
};

export const SessionExamEnrollmentStatus = {
  None: 0,
  NoAttestationsEnrollment: 1,
  RegularEnrollment: 2,
  RetakingEnrollment: 3,
  NotAdmitted: 4,
};

export const PracticalExamStatus = {
  NotGraded: 1,
  Passed: 2,
  Failed: 3,
};

export const DoctoralRankingStatus = {
  Pending: 1,
  Draft: 2,
  Approved: 3,
};

export const DoctoralSchoolCampaignStatus = {
  Draft: 1,
  OpenForEnrollment: 2,
  InProgress: 3,
  Completed: 4,
};

export const DoctoralSchoolDoctorantStatus = {
  Pending: 1,
  Accepted: 2,
};

export const DoctoralSchoolResult = {
  Passed: 1,
  Failed: 2,
};

export const DoctoralSchoolDoctorantOrigin = {
  Internal: 1,
  External: 2,
};

export const DoctoralSchoolPaymentProvider = {
  BankTransfer: 3,
  OnSite: 4,
};

export const DoctoralRankingResultStatus = {
  NotAccepted: 1,
  Accepted: 2,
  AcceptedInHigherPriority: 3,
};

export const AcademicRequestType = {
  AcademicReport: 1,
  CreditReport: 2,
  TransferredDataIssue: 3,
};

export const ExamTypes = {
  Remote: 1,
  InPerson: 2,
};

export const ExamCategories = {
  Written: 1,
  Oral: 2,
  Practical: 3,
  DocumentBased: 4,
};

export const CampaignTypes = {
  PreparatoryCourses: 7,
};

export const CampaignSubTypes = {
  Preliminary: 1,
  Regular: 2,
  Paid: 4,
  Preparatory: 5,
  HospitalContract: 6,
};

export const EnrollmentFormType = {
  AcceptedCandidate: 1,
  OtherUniversity: 2,
  Pms: 3,
  IndividualOrder: 4,
};

export const CampaignSubTypeLabels = {
  1: "Предварителна кампания",
  2: "Редовна кампания",
  4: "Платена кампания",
  6: "Договор с болница",
};

export const CampaignSubTypePaths = {
  1: PRELIMINARY,
  2: REGULAR,
  4: PAID,
  5: COURSES,
  6: HOSPITAL_CONTRACTS,
};

export const ScoreComponentSource = {
  Exam: 1,
  SchoolSubject: 2,
};

export const RankingStatus = {
  Pending: 0,
  Draft: 1,
  Approved: 2,
};

export const RankingType = {
  State: 0,
  Paid: 1,
  HospitalContract: 2,
};

export const RankingResultStatus = {
  NotAccepted: 0,
  Accepted: 1,
  Enrolled: 2,
  DroppedOut: 3,
  AcceptedInHigherPriority: 4,
  TransferredToStateOrder: 5,
};

export const CandidacyStates = {
  Approved: 1,
  WaitingApproval: 2,
  WaitingManualPayment: 7,
};

export const SpecialistsCandidacyStates = {
  Submitted: 1,
  Approved: 2,
  Rejected: 3,
  WaitingCorrection: 4,
};

export const RankingResultCategory = {
  Common: 0,
  Men: 1,
  Women: 2,
  Preferences: 3,
  RestoredRights: 4,
};

export const RankingResultEnroll = {
  Common: "Общo",
  Male: "Мъже",
  Female: "Жени",
  Priority: "По приоритет",
  Reinstanted: "Възстановяващ права",
};

export const SpecialityStatusSource = {
  Active: 1,
  NoAdmission: 2,
  Inactive: 3,
};

export const CitizenshipIds = {
  Bulgarians: 1,
  EuForeigners: 2,
  NotEuForeigners: 3,
};

export const AnnualFeeModes = {
  Calculated: 1,
  Fixed: 2,
};

export const PaymentProvider = {
  CardPayment: 1,
  Epay: 2,
  BankTransfer: 3,
  CashPayment: 4,
};

export const DynamicDeclarations = {
  ForeignerNoteId: 24,
  ForeignerPreparatoryNoteId: 25,
};

// What a declaration row action does with the document: preview it in a new tab or download it.
export const DocumentAction = {
  Preview: "preview",
  Download: "download",
};

export const AdminExamsPaymentMethod = {
  CashPayment: 0,
  BankTransfer: 1,
  NoPayment: 2,
};

export const NotOnlinePaidMethods = [
  { id: AdminExamsPaymentMethod.CashPayment, name: "Платено на каса" },
  { id: AdminExamsPaymentMethod.BankTransfer, name: "Платено по банка" },
];

export const FreeEnrolingPaymentMethod = [
  { id: AdminExamsPaymentMethod.NoPayment, name: "Освободен от семестриална такса" },
];

export const CampaignSubType = {
  Preliminary: 1,
  Regular: 2,
  Additional: 3,
  Paid: 4,
};

export const StudentExamStatus = {
  NotAttended: 2,
  Attended: 3,
  Disqualified: 4,
};

export const StudentStateExamStatus = {
  Attended: 1,
  NotAttended: 2,
  Disqualified: 3,
};

export const TaxTypes = {
  CandidateExams: 1,
  CandidateDocumentProcessing: 2,
  Semester: 3,
  CandidateSpecialities: 4,
  CandidateCourses: 5,
};

export const WeeklyScheduleStatuses = { New: 1, Approved: 2 };

export const WeeklyScheduleStatusesTexts = {
  1: "Нов",
  2: "Одобрен",
};

export const PreparatoryScheduleStatuses = { New: 1, Approved: 2 };

export const PreparatoryScheduleStatusesTexts = {
  1: "Нов",
  2: "Одобрен",
};

export const CareerRequestStatus = {
  Inactive: 0,
  NotVerifiedValidationCode: 1,
  WaitingForCorrection: 2,
  Active: 3,
  CorrectionApplied: 4,
  Rejected: 5,
};

export const ClassTypes = {
  Csc: 1,
  Lectures: 2,
  Exercies: 3,
  Practices: 4,
};

export const EnrollmentStatesTexts = {
  enrolled: "Записан",
  enrolling: "Записва се (чака одобрени/плащане)",
  unenrolled: "Не е записан",
};

export const AcademicSessionTypes = {
  SummerSemester: 1,
  SummerSession: 2,
  WinterSemester: 3,
  WinterSession: 4,
  CorrectionSession: 5,
  LiquidationSession: 6,
  ExtendedSession: 7,
};

export const NotPastExamsStudentsTypes = {
  CountOfStudents: 1,
  FacultyNumbers: 2,
};

export const Gender = {
  Male: 1,
  Female: 2,
};

export const ScheduleView = {
  table: "table",
  calendar: "calendar",
};

export const IdType = {
  EGN: 1,
  PNF: 2,
  PID: 3,
};

export const IdTypeName = {
  EGN: "ЕГН",
  PNF: "ЛНЧ",
  PID: "ПИД",
};

export const IntendedFor = {
  Regular: 1,
  RegularAndNotPastExamsStudents: 2,
  OnlyNotPastExamsStudents: 3,
  Individual: 4,
};

export const ViewTypeSchedule = {
  Room: "room",
  Professor: "professor",
  Student: "student",
  StudyGroup: "studyGroup",
};

export const EducationType = {
  Regular: 1,
  Preparatory: 2,
};

export const DecisionReasons = {
  MissingAttestations: 1,
  FailedRequiredDiscipline: 2,
  FailedTooManyDisciplines: 3,
  FailedCarryOverDisciplines: 4,
};

export const DecisionTypes = {
  Advancement: 1,
  Interruption: 2,
};

export const StudyTypes = {
  Full_time: 1,
  Part_time: 2,
  Remote: 3,
};

export const StudyTypeLabels = {
  1: "редовно",
  2: "задочно",
  3: "дистанционно",
};

export const EducationStatuses = {
  Active: "Действащ",
  Graduate: "Дипломиран",
  GraduationProcess: "В Процес на дипломиране",
};

export const PaymentStatuses = {
  Paid: 0,
  NotPaid: 1,
  WaitingPayment: 2,
};

export const CandidatePaymentStatus = {
  ExemptFromFee: 1,
  NotPaidOnline: 2,
  PaidOnline: 3,
};

export const CandidatePaymentStatusTitles = {
  [CandidatePaymentStatus.ExemptFromFee]: "Освободен от такса",
  [CandidatePaymentStatus.NotPaidOnline]: "Не е платено онлайн",
  [CandidatePaymentStatus.PaidOnline]: "Платено онлайн",
};

export const CurriculumControlForms = {
  GradeAfterCycle: 4,
};

// `None` also marks an attestation for a discipline that is no longer part of the curriculum
// (transferred / legacy) - such rows can be edited but no new ones can be added for them.
export const CurriculumDisicplineTypes = {
  None: 0,
  Regular: 1,
  Elective: 2,
  Facultative: 3,
  Cyclic: 4,
};

export const DisciplineCategory = {
  Regular: 1,
  Sport: 2,
  ForeignLanguage: 3,
};

export const Currency = {
  EUR: "EUR",
  BGN: "BGN",
};

export const CurrencyTypes = {
  BGN: 0,
  EUR: 1,
};

export const DebtStatus = {
  Unpaid: 0,
  Paid: 1,
  Cancelled: 2,
};

export const DepositAction = {
  Create: 1,
  Use: 2,
};

export const UserRoles = {
  Candidate: "Candidate",
  Student: "Student",
  Specialist: "Specialist",
  Doctorant: "Doctorant",
};

export const StaffRequestTypes = {
  ScheduleSubstitution: 1,
  ClassesMakeUp: 2,
  AnnualLeave: 3,
  SickLeave: 4,
  BusinessTrip: 5,
  ErasmusSignature: 6,
  CancelAbsence: 7,
};

export const StaffRequestTitles = {
  [StaffRequestTypes.ScheduleSubstitution]: "Заявка за заместване на преподавател",
  [StaffRequestTypes.ClassesMakeUp]: "Заявка за отработване на упражнения",
  [StaffRequestTypes.AnnualLeave]: "Заявка за отпуска",
  [StaffRequestTypes.SickLeave]: "Заявка за болничен",
  [StaffRequestTypes.BusinessTrip]: "Командировка",
  [StaffRequestTypes.ErasmusSignature]: "Заявка за Еразъм подпис",
  [StaffRequestTypes.CancelAbsence]: "Заявка за отмяна",
};

// Subject of the approve/reject confirmation question, in the genitive.
export const StaffRequestActionSubjects = {
  [StaffRequestTypes.ScheduleSubstitution]: "заявката за заместване на преподавател",
  [StaffRequestTypes.ClassesMakeUp]: "заявката за отработване на упражнения",
  [StaffRequestTypes.AnnualLeave]: "заявката за отпуска",
  [StaffRequestTypes.SickLeave]: "заявката за болничен",
  [StaffRequestTypes.BusinessTrip]: "заявката за командировка",
  [StaffRequestTypes.ErasmusSignature]: "заявката за Еразъм подпис",
  [StaffRequestTypes.CancelAbsence]: "заявката за отмяна",
};

export const StaffRequestStatuses = {
  Pending: 0,
  Approved: 1,
  Rejected: 2,
  Cancelled: 3,
};

// Once approved, only these types may still be cancelled, and only through an approval request.
export const CANCELABLE_WHEN_APPROVED_TYPES = [StaffRequestTypes.AnnualLeave, StaffRequestTypes.BusinessTrip];

export const LEAVE_DOCUMENTS_ATTACHABLE_STATUSES = [
  StaffRequestStatuses.Pending,
  StaffRequestStatuses.Approved,
  StaffRequestStatuses.Cancelled,
];

export const StaffRequestBulkAction = {
  Confirm: "confirm",
  Reject: "reject",
};

export const LeaveTypes = {
  Vacation: 1,
  BusinessTrip: 2,
  SickLeave: 3,
};

export const BusinessTripTypes = {
  Internal: 1,
  International: 2,
};

export const TransportTypes = {
  UniversityCar: 1,
  PersonalCar: 2,
  BusOrTrain: 3,
  Plane: 4,
  TravelsInAnotherColleaguesCar: 6,
  PersonalCarElectric: 7,
};

export const DomesticTripCategories = {
  Staff: 1,
  Jury: 2,
  Student: 3,
};

export const TravelerKinds = {
  Employee: 1,
  External: 2,
  Student: 3,
  Doctoral: 4,
};

export const PERSONAL_CAR_TRANSPORT_TYPES = [TransportTypes.PersonalCar, TransportTypes.PersonalCarElectric];

export const EmployeePositionTypes = {
  Administration: "Administration",
  Professors: "Professors",
};

export const AlumniCareerStatuses = {
  WaitingApproved: 1,
  WaitingCorrection: 2,
  CorrectionApplied: 3,
  Active: 4,
  Stopped: 6,
  Rejected: 5,
};

export const ScholarshipStatuses = {
  Blocked: -1,
  Pending: 0,
  Approved: 1,
  Excluded: 2,
  PendingAccounting: 3,
  ReturnedForCorrection: 4,
};

export const ScholarshipTypes = {
  Grade: 1,
  GradeAndIncome: 2,
  Income: 3,
  InternationalExchange: 4,
};

export const InternshipPlanScheduleTypes = {
  Cyclical: 1,
  IndividualCycles: 2,
  Individual: 3,
  FreeHourSelection: 4,
};

export const TransactionStatuses = {
  Paid: "Платено",
  NotPaid: "Неплатено",
  Processing: "Обработва се",
  Transferred: "Прехвърлено",
};

export const DebtStatuses = {
  Active: "Активно",
  Paid: "Платено",
  Cancelled: "Отменено",
};

export const StateExamAssignmentType = {
  Selectable: 1,
  ForStudyGroups: 2,
};

export const StateExamTypes = {
  Single: 1,
  Group: 2,
};

export const ErasmusIncomingType = {
  Regular: "regular",
  Intership: "intership",
};

export const DocumentsType = {
  PUBLIC: "public",
  PRIVATE: "private",
};

export const ErasmusInternshipStatus = {
  New: 1,
  CoordinatorApproved: 2,
  CoordinatorRejected: 3,
  Arrived: 4,
  Finished: 5,
  PrintedLoA: 6,
};

// The single-file id fields on an outgoing employee mobility, in display order.
// Shared by the admin detail (Erasmus/OutgoingTeachers/Partials/ShowForm.js) and the employee's own
// read-only view (Erasmus/MyOutgoingMobilities/MobilityDocuments.js) so the two never drift apart.
export const ErasmusOutgoingEmployeeDocuments = [
  { source: "mobilityAgreementId", label: "Споразумение за мобилност" },
  { source: "cvId", label: "CV" },
  { source: "selectionProtocolId", label: "Протокол за подбор" },
  { source: "fundingAgreementId", label: "Споразумение за финансиране" },
  { source: "acceptanceLetterId", label: "Писмо за приемане" },
  { source: "certificateOfStayId", label: "Удостоверение за престой" },
  { source: "certificateOfTeachingId", label: "Удостоверение за преподаване" },
  { source: "businessTripReportId", label: "Доклад от командировка" },
  { source: "businessTripOrderId", label: "Заповед за командировка" },
  { source: "medicalInsuranceId", label: "Медицинска застраховка" },
  { source: "travellerReportId", label: "Доклад на пътуващия" },
];

// Generated documents for an incoming internship student. Each one is served from its own status
// window; the status ids do not follow the process order (PrintedLoA is 6, after Finished), so the
// windows are listed explicitly. `path` is both the url segment and the downloaded file name.
export const ErasmusInternshipDocuments = [
  {
    label: "Писмо за приемане",
    path: "letter-of-acceptance",
    statuses: [ErasmusInternshipStatus.CoordinatorApproved, ErasmusInternshipStatus.PrintedLoA],
    // the only document that advances the status - CoordinatorApproved becomes PrintedLoA
    advancesStatus: true,
  },
  {
    label: "Доклад за общежитие",
    path: "dormitory-report",
    statuses: [ErasmusInternshipStatus.PrintedLoA, ErasmusInternshipStatus.Arrived, ErasmusInternshipStatus.Finished],
  },
  {
    label: "Служебна бележка транспорт",
    path: "transport-note",
    statuses: [ErasmusInternshipStatus.PrintedLoA, ErasmusInternshipStatus.Arrived, ErasmusInternshipStatus.Finished],
  },
  {
    label: "Удостоверение за пристигане",
    path: "certificate-of-arrival",
    // the only document generated from user input - the coordinator fills in the host university,
    // the host country and the email before it is downloaded
    requiresForm: true,
    statuses: [ErasmusInternshipStatus.Arrived, ErasmusInternshipStatus.Finished],
  },
  {
    label: "Удостоверение за престой",
    path: "certificate-of-stay",
    statuses: [ErasmusInternshipStatus.Finished],
  },
  {
    label: "Академична справка",
    path: "certificate-of-traineeship",
    statuses: [ErasmusInternshipStatus.Finished],
  },
];

export const InternshipStudentStatuses = {
  None: "None",
  Active: "Active",
  PassedLessons: "PassedLessons",
  Completed: "Completed",
};

export const ApproveApplicationStatuses = {
  Dean_Approve: 5,
  Coordinator_Approve: 3,
  Rector_Approve: 7,
  Arrive_Not_Approve: 2,
  Created_Not_Approve: 1,
};

export const ErasmusRegularStudentStatus = {
  Created: 1,
  Signed: 2,
  PrintedLoa: 3,
  Arrived: 4,
  Finished: 5,
};

// Generated documents for an incoming regular student. Each one is served from its own status
// window; `path` is both the url segment and the downloaded file name.
export const ErasmusRegularStudentDocuments = [
  {
    label: "Писмо за приемане",
    path: "letter-of-acceptance",
    statuses: [ErasmusRegularStudentStatus.Signed, ErasmusRegularStudentStatus.PrintedLoa],
    // the only document that advances the status - Signed becomes PrintedLoa
    advancesStatus: true,
  },
  {
    label: "Доклад за общежитие",
    path: "dormitory-report",
    statuses: [
      ErasmusRegularStudentStatus.PrintedLoa,
      ErasmusRegularStudentStatus.Arrived,
      ErasmusRegularStudentStatus.Finished,
    ],
  },
  {
    label: "Служебна бележка транспорт",
    path: "transport-note",
    statuses: [
      ErasmusRegularStudentStatus.PrintedLoa,
      ErasmusRegularStudentStatus.Arrived,
      ErasmusRegularStudentStatus.Finished,
    ],
  },
  {
    label: "Удостоверение за пристигане",
    path: "certificate-of-arrival",
    // the only document generated from user input - the coordinator fills in the host university,
    // the host country and the email before it is downloaded
    requiresForm: true,
    statuses: [ErasmusRegularStudentStatus.Arrived, ErasmusRegularStudentStatus.Finished],
  },
  {
    label: "Удостоверение за престой",
    path: "certificate-of-stay",
    statuses: [ErasmusRegularStudentStatus.Finished],
  },
  {
    label: "Академична справка",
    path: "transcript-of-record",
    statuses: [ErasmusRegularStudentStatus.Finished],
    // a BIP student has no disciplines, so there is nothing to certify
    excludesBip: true,
  },
];

export const ErasmusApplicationStatuses = {
  Submitted: 1,
  Rejected: 2,
  DocumentApproved: 3,
  DocumentRejected: 4,
  InterviewScheduled: 5, // добавяне на интервю
  InterviewApproved: 6, // добавяне на университет
  InterviewRejected: 7,
  DeanApproved: 8,
  DeanRejected: 9,
  RectorApproved: 10,
  RectorRejected: 11,
  ContractGenerated: 12,
  FinalApproved: 13, // добавяне на funding
  FundingAssigned: 14,
  ReturnedStudent: 15,
  GradesEntered: 16,
  Closed: 17,
  ReturnedForCorrection: 18,
};

// every rejection target accepts an optional comment explaining the decision
export const ERASMUS_REJECTION_STATUSES = [
  ErasmusApplicationStatuses.Rejected,
  ErasmusApplicationStatuses.DocumentRejected,
  ErasmusApplicationStatuses.InterviewRejected,
  ErasmusApplicationStatuses.DeanRejected,
  ErasmusApplicationStatuses.RectorRejected,
];

// the report is generated only once the student is approved after the interview
export const ERASMUS_BUSINESS_TRIP_REPORT_STATUSES = [
  ErasmusApplicationStatuses.InterviewApproved,
  ErasmusApplicationStatuses.DeanApproved,
  ErasmusApplicationStatuses.RectorApproved,
  ErasmusApplicationStatuses.ContractGenerated,
  ErasmusApplicationStatuses.FinalApproved,
  ErasmusApplicationStatuses.FundingAssigned,
  ErasmusApplicationStatuses.ReturnedStudent,
  ErasmusApplicationStatuses.GradesEntered,
  ErasmusApplicationStatuses.Closed,
];

export const ThesisDefenseRequestAction = {
  Approve: "approve",
  Reject: "reject",
};

export const ThesisDefenseRequestStatus = {
  Pending: 1,
  Approved: 2,
  Rejected: 3,
};

export const HealthcareApplicationStatus = {
  Submitted: 1,
  Approved: 2,
  Rejected: 3,
  Completed: 4,
};

export const HealthcareApplicationOrigin = {
  PublicForm: 1,
  Admin: 2,
};

export const ExamCommitteeStatus = {
  Active: 1,
  Inactive: 2,
};

export const CurriculumItemTypes = {
  Theoretical: 1,
  Practical: 2,
  Colloquium: 3,
};

export const SpecializationTypes = {
  Clinical: 1,
  NonClinical: 2,
};

export const SpecialistsEnrollmentType = {
  Clinical: "clinical",
  NonClinical: "non-clinical",
};

export const SpecialistStatuses = {
  Active: 1,
  WaitingForAttestation: 2,
  EligibleForGraduation: 3,
  Graduating: 4,
};

export const AdvancedSpecialistStatuses = {
  InTraining: 1,
  Graduated: 2,
  NotGraduated: 3,
};
export const DetailsLeaveType = [
  { id: StaffRequestTypes.AnnualLeave, name: "Отпуска" },
  { id: StaffRequestTypes.SickLeave, name: "Болничен" },
  { id: StaffRequestTypes.BusinessTrip, name: "Командировка" },
];

export const MobilityVisitType = {
  Training: 1,
  Internship: 2,
  BIP: 3,
};

export const DormitoryBuildingStatuses = {
  Active: 1,
  Inactive: 2,
};

export const DormitoryRoomStatuses = {
  Active: 1,
  Inactive: 2,
};

export const DormitoryRoomTypeStatuses = {
  Active: 1,
  Inactive: 2,
};

export const DormitoryRoomConditionStatuses = {
  Active: 1,
  Inactive: 2,
};

export const DormitoryCampaignStatuses = {
  Draft: 1,
  Confirmed: 2,
  Finished: 3,
  Cancelled: 4,
};

export const DormitoryCampaignApplicantTypes = {
  Internal: 1,
  External: 2,
};

export const DormitorySettingTypes = {
  ExtraBedMarkup: 1,
};

export const DormitoryAccommodationStatuses = {
  Active: 1,
  Left: 2,
};

export const DormitoryAccommodationOrderStatuses = {
  Draft: 1,
  ForSignature: 2,
  Signed: 3,
  Cancelled: 4,
};

export const DormitoryAccommodationPaymentStatuses = {
  Pending: 1,
  Paid: 2,
};

export const DormitoryAccommodationPaymentReportingStates = {
  NotAttempted: 1,
  InProgress: 2,
  Confirmed: 3,
  ReviewRequired: 4,
};

export const DormitoryManualPaymentMethods = {
  Cash: 1,
  BankTransfer: 2,
};

export const DormitoryStudentTypes = {
  Bachelor: 1,
  Master: 2,
  Doctoral: 3,
};

export const DormitoryRoomExpositions = {
  North: 1,
  South: 2,
  East: 3,
  West: 4,
  Northeast: 5,
  Southeast: 6,
  Southwest: 7,
  Northwest: 8,
  Center: 9,
};

export const STUDENT_CATEGORIES = {
  INTERNAL: "internal",
  EXTERNAL: "external",
};

export const PreferenceOrigin = {
  Student: "student",
  Candidacy: "candidacy",
};

// НАЦИД flow engine. Values mirror the backend's Postgres enums exactly; the Bulgarian labels in
// utils/choices.js are copied verbatim from the [DisplayText] attributes so Swagger and the panel agree.
export const NacidFlowStatus = {
  Pending: 1,
  InProgress: 2,
  WaitingForRetry: 3,
  WaitingForManualAction: 4,
  Completed: 5,
  Failed: 6,
  Cancelled: 7,
};

export const NacidFlowStepStatus = {
  Pending: 1,
  InProgress: 2,
  Succeeded: 3,
  SkippedAlreadyApplied: 4,
  WaitingForRetry: 5,
  WaitingForManualAction: 6,
  Failed: 7,
  Cancelled: 8,
};

export const NacidFlowType = {
  CreatePerson: 1,
  CreateForeignPerson: 2,
  EnrollStudent: 3,
  AdvanceSemester: 4,
  InterruptStudies: 5,
  RestoreStudentRights: 6,
  TransferSpecialityInternal: 7,
  TransferUniversityOut: 8,
  IncomingMobility: 9,
  SecondSpeciality: 10,
  TerminateStudies: 11,
  GraduateStudent: 12,
  RecordProtocol: 13,
  IssueDiploma: 14,
  UpdatePersonContacts: 15,
  UpdatePreviousEducation: 16,
  UpdateFacultyNumber: 17,
  RepairPeriod: 18,
};

export const NacidFlowSource = {
  Event: 1,
  SystemApi: 2,
  RecoveryJob: 3,
  Admin: 4,
};

export const PublicationSource = {
  Scopus: 1,
  WebOfScience: 2,
};

export const NacidFailureClass = {
  Transient: 1,
  RateLimited: 2,
  AlreadyApplied: 3,
  BusinessRejection: 4,
  Validation: 5,
  ManualIntervention: 6,
  Unknown: 7,
};

export const NacidProbeOutcome = {
  NotProbed: 1,
  Absent: 2,
  Present: 3,
  Unavailable: 4,
};

// Two Latin letters + five digits. НАЦИД's alphabet excludes I, J, O, U and W — the characters an operator
// most easily mistypes when copying an ЕАН out of НАЦИД's UI or its Excel export.
export const NACID_EAN_PATTERN = /^[A-HK-NP-TVXYZa-hk-np-tvxyz]{2}\d{5}$/;
